<!-- 

    增加金流收款方式開關

    新頁面 ( 付款設定 )：

    (管理者跟員工)

 -->

<template>
  <v-container fluid>
    <v-layout v-if="!isEdit">
      <v-spacer></v-spacer>
      <v-btn color="blue lighten-2" class="mb-4" @click="isEdit = true"
        >編輯</v-btn
      >
    </v-layout>
    <!-- 台新 -->
    <v-layout>
      <v-switch
        v-model="settings.TSPG.enable"
        inset
        label="台新"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.TSPG.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <!-- 藍新 -->
    <v-layout>
      <v-switch
        v-model="settings.CREDIT.enable"
        inset
        label="藍新"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.CREDIT.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <!-- 綠界 -->
    <v-layout>
      <v-switch
        v-model="settings.ECPAY.enable"
        inset
        label="綠界"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.ECPAY.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <!-- 街口 -->
    <v-layout>
      <v-switch
        v-model="settings.JKO.enable"
        inset
        label="街口"
        :readonly="!isEdit"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.JKO.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <!-- ATM -->
    <v-layout>
      <v-switch
        v-model="settings.ATM.enable"
        inset
        label="ATM"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.ATM.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <!--  AFTEE -->
    <v-layout>
      <v-switch
        v-model="settings.AFTEE.enable"
        inset
        label="AFTEE"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
      <v-textarea
        outlined
        label="說明文字"
        auto-grow
        v-model="settings.AFTEE.comment"
        class="ml-4"
        color="blue accent-2"
        background-color="blue lighten-5"
        :disabled="!isEdit"
      ></v-textarea>
    </v-layout>

    <v-layout v-if="isEdit">
      <v-spacer></v-spacer>
      <v-btn color="blue-grey lighten-4" class="" @click="cancel()">取消</v-btn>
      <v-btn color="green lighten-2" class="ml-3" @click="saveSetting()"
        >儲存</v-btn
      >
    </v-layout>
  </v-container>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";
export default {
  name: "paymentSettings",
  mixins: [common],
  data() {
    return {
      // 藍新/綠界/ATM/街口/TSPG
      isEdit: false,
      // settings: {},
      settings: {
        // 藍新
        CREDIT: {
          enable: false,
          comment: "",
        },
        ATM: {
          enable: false,
          comment: "",
        },
        // 綠界
        ECPAY: {
          enable: false,
          comment: "",
        },
        // 台新
        TSPG: {
          enable: false,
          comment: "",
        },
        // 街口
        JKO: {
          enable: false,
          comment: "",
        },
        // AFTEE
        AFTEE: {
          enable: false,
          comment: "",
        },
      },
    };
  },
  watch: {},
  methods: {
    ...mapActions(["getPaymentSetting", "savePaymentSetting"]),

    // 載入資料
    async loadData() {
      try {
        this.loading = true;
        const res = await this.getPaymentSetting();
        if (res.data.statusCode === 0) {
          // console.log(`getPaymentSetting ${JSON.stringify(res.data)}`);
          const data = res.data.data;
          // console.log(`getPaymentSetting ${JSON.stringify(this.settings)}`);

          // 將資料轉換為以 paymentId 為鍵的物件
          data.forEach((item) => {
            if (this.settings[item.paymentId]) {
              this.settings[item.paymentId].enable = item.enable;
              this.settings[item.paymentId].comment = item.comment;
            }
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(`getPaymentSetting error`, e.stack);
      } finally {
        this.loading = false;
      }
    },
    // 儲存
    async saveSetting() {
      console.log(`saveSetting data = ${JSON.stringify(this.settings)}`);

      try {
        this.loading = true;

        // 將 settings 物件轉換回原始的資料格式
        const data = Object.entries(this.settings).map(
          ([paymentId, setting]) => ({
            paymentId,
            ...setting,
          })
        );

        console.log(`savePaymentSetting ${JSON.stringify(data)}`);

        const res = await this.savePaymentSetting(data);

        if (res.data.statusCode === 0) {
          console.log(`savePaymentSetting ${JSON.stringify(res.data)}`);

          // this.settings = res.data.data;

          this.loadData();
          this.isEdit = false;
        }
      } catch (e) {
        this.loading = false;
        console.log(`saveTagInfo error`, e.stack);
      } finally {
        this.loading = false;
      }

      // console.log(`saveSetting data = ${JSON.stringify(data)}`);

      this.isEdit = false;
    },
    // 取消
    cancel() {
      this.isEdit = false;
      this.loadData();
    },
    // async fetchSettings() {
    //   // 從 API 獲取設定資料

    // },
  },
  //  頁面載入時加載資料
  created() {
    this.loadData();
  },
};
</script>

<style scoped></style>
